import { gql } from 'graphql.macro';
import { orgContactFragment } from './common';

export const connectedLabFragment = gql`
    fragment connectedLabFields on ConnectedLab {
        isDisabled
        isRequireException
        lab {
            _id
            name
            hexCode
            textCode
            logoSignedUrl
        }
    }
`;

export const labFragment = gql`
    fragment labFields on Organization {
        _id
        hitHorizonsId
        name
        officialName
        organizationNumber
        contact {
            ...orgContactFields
        }
        active
        created {
            on
        }
    }
    ${orgContactFragment}
`;
